// extracted by mini-css-extract-plugin
module.exports = {"light":"1","medium":"1","strong":"1","extraStrong":"1"};